<div
  class="main-item-container"
  tabindex="0"
  role="button"
  fxLayout="row"
  fxLayoutAlign="space-between center"
  (click)="onItemClicked(item)"
  (keydown)="onItemKeydown($event, item)"
>
  <div fxFlex fxLayout="column" class="details">
    <span class="entity-name" [matTooltip]="item.name">{{ item.name }}</span>
    <span class="credential-name" [matTooltip]="item.credentialName">{{
      item.credentialName
    }}</span>
  </div>

  <div fxFlex="none" fxLayout="column" fxLayoutAlign="center end">
    <span class="status">{{ item.applicationStatusLabel }}</span>
    <span class="updated-on">{{
      item.credentialApplicationUpdatedOn | dateDifference
    }}</span>
  </div>
</div>
